<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    Contact
                  </h2>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="col-12">
                  <p class="mb-4">
                    You can contact us via <a href="mailto:acdc.dataset@zohomail.eu">e-mail</a>
                    for any question, comment or feedback you have.
                  </p>
                </div>
              </div>

            </div>
          </section>
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h3 class="text-black mb-0">
                    Team
                  </h3>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="col-12">
                  <table style="width:100%">
                    <tr>
                      <td style="text-align:center">
                        <img height=200px src="/imgs/christos.jpg"
                        />
                      </td>
                      <td style="text-align:center">
                        <img height=200px src="/imgs/haoran.png"
                        />
                      </td>
                      <td style="text-align:center">
                        <img height=200px src="/imgs/dengxin.jpeg"
                        />
                      </td>
                      <td style="text-align:center">
                        <img height=200px src="/imgs/luc.jpg"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align:center; vertical-align:top">
                        <a href="https://people.ee.ethz.ch/~csakarid">Christos Sakaridis</a>
                        <br/>
                        ETH Zurich
                      </td>
                      <td style="text-align:center; vertical-align:top">
                        <a href="https://www.mpi-inf.mpg.de/departments/computer-vision-and-machine-learning/people/haoran-wang">Haoran Wang</a>
                        <br/>
                        MPI for Informatics
                      </td>
                      <td style="text-align:center; vertical-align:top">
                        <a href="https://vas.mpi-inf.mpg.de/dengxin">Dengxin Dai</a>
                        <br/>
                        Huawei Zurich
                      </td>
                      <td style="text-align:center; vertical-align:top">
                        <a href="https://vision.ee.ethz.ch/people-details.OTAyMzM=.TGlzdC8zMjQ4LC0xOTcxNDY1MTc4.html">Luc Van Gool</a>
                        <br/>
                        ETH Zurich
                        <br/>
                        KU Leuven
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

            </div>
          </section>
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h3 class="text-black mb-0">
                    Privacy
                  </h3>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="col-12">
                  <p class="mb-4">
                    ACDC is made available for non-commercial use only.
                    However, if you find yourself or your personal belongings
                    in the dataset, you can
                    <a href="mailto:acdc.dataset@zohomail.eu">contact us</a>
                    and we will immediately delete the respective images from
                    our server.
                  </p>
                </div>
              </div>

            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  name: "ContactPage.vue",
  components: {
    NavigationMain
  }
};
</script>
